import React from "react";
import Wave from "../assets/svgs/handemoji.svg";
import BusCard from "../components/SignUpCard";
import s from "../styles/LogIn.module.css";
import googleicon from "../assets/icons/googleicon.svg";
import standing from "../assets/images/standing.png"
import line from "../assets/svgs/line.svg";
import { useFormik } from "formik";
import * as yup from "yup";
import caution from "../assets/svgs/caution.svg";

// onChange, onBlur,touched, onSubmit, errors, value, isSubmitting

const onSubmit = async (values, actions) => {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  actions.resetForm();
};

const FormSchema = yup.object().shape({
  email: yup.string().email("Please enter a valid email").required("Required"),
  password: yup.string().min(8).required("Required"),
});

const LogIn = () => {
  const {
    handleChange,
    handleBlur,
    touched,
    handleSubmit,
    errors,
    values,
    isSubmitting,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: FormSchema,
    onSubmit,
  });
  console.log(values);
  return (
    <div className={s.overall}>
    <BusCard image = {standing}/>
      <div className={s.container}>
        
        <div className={s.Login}>
          <div className={s.Welcome}>
            <p className={s.head}>Welcome back</p>
            <img src={Wave} alt="hand waving emoji" className={s.wave} />
          </div>
          <div className={s.book}>
            <p className={s.choice}>
              You can book any bus to any destination of your <br></br>choice.
            </p>
          </div>
          <div className={s.login}>
            <button className={s.btn}>
              <img src={googleicon} className={s.gicon} alt="google icon" />
              Log in with Google
            </button>

            <div className={s.or}>
              <img src={line} alt="decorative line" className={s.line} />
              <p className={s.orText}>or</p>
              <img src={line} alt="decorative line" className={s.line} />
            </div>

            <form onSubmit={handleSubmit} action="">
              <label htmlFor="" className={s.lbl}>
                Email Address
              </label>
              <input
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                type="email"
                name="email"
                id="email"
                placeholder="eg praiseosai@gmail.com"
                className={errors.email && touched.email ? s.input : ""}
              />

              {errors.email && touched.email && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.email}
                </p>
              )}

              <label htmlFor="" className={s.lbl}>
                Password
              </label>
              <input
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                type="password"
                name="password"
                id="password"
                className={errors.password && touched.password ? s.input : ""}
              />
              {errors.password && touched.password && (
                <p className={s.error}>
                  <img src={caution} alt="" className={s.caution} />
                  {errors.password}
                </p>
              )}

              <p className={s.forgotPassword}>
                <a href="/forgot-password">Forgot Password?</a>
              </p>
              <button type="submit" className={s.submit}>
                Log in
              </button>
            </form>

            <p className={s.noAccount}>
              Dont have an account?{" "}
              <span>
                <a href="/register">Register</a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
